import { api } from "@/api/client";

// Tax & Books — country-adaptive bookkeeping (Phase 1).
export const booksApi = {
  settings: () => api.get("/books/settings").then((r) => r.data),
  saveSettings: (patch) => api.put("/books/settings", patch).then((r) => r.data),
  jurisdictions: () => api.get("/books/jurisdictions").then((r) => r.data),
  entries: ({ tax_year, entity, direction } = {}) => {
    const p = new URLSearchParams();
    if (tax_year) p.set("tax_year", tax_year);
    if (entity) p.set("entity", entity);
    if (direction) p.set("direction", direction);
    const qs = p.toString();
    return api.get(`/books/entries${qs ? `?${qs}` : ""}`).then((r) => r.data);
  },
  addEntry: (payload) => api.post("/books/entry", payload).then((r) => r.data),
  updateEntry: (id, payload) => api.patch(`/books/entry/${id}`, payload).then((r) => r.data),
  deleteEntry: (id) => api.delete(`/books/entry/${id}`).then((r) => r.data),
  summary: (tax_year) => api.get(`/books/summary${tax_year ? `?tax_year=${tax_year}` : ""}`).then((r) => r.data),
  gst: (tax_year, quarter) => api.get(`/books/gst?tax_year=${tax_year}&quarter=${quarter}`).then((r) => r.data),
  exportDocument: (tax_year) => api.post(`/books/documents/export${tax_year ? `?tax_year=${tax_year}` : ""}`).then((r) => r.data),
  documents: (tax_year) => api.get(`/books/documents${tax_year ? `?tax_year=${tax_year}` : ""}`).then((r) => r.data),
  setLegalHold: (id, hold) => api.post(`/books/entry/${id}/hold`, { hold }).then((r) => r.data),
  uploadAttachment: (id, file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post(`/books/entry/${id}/attachment`, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
  autoSync: (payload) => api.post("/books/auto/sync", payload).then((r) => r.data),
  vaultSync: () => api.post("/books/auto/vault-sync").then((r) => r.data),
  setLegalApproval: (approved) => api.post("/books/admin/legal-approval", { approved }).then((r) => r.data),
  syncStatus: () => api.get("/books/sync-status").then((r) => r.data),
};
